import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useGoogleLogin } from "@react-oauth/google";

import useDrivePicker from "react-google-drive-picker";
import { CardPersonIcon } from "../../../../assets/image/CardPersonIcon";
import { PowerIcon } from "../../../../assets/image/PowerIcon";
import { LaptopIcon } from "../../../../assets/image/LaptopIcon";

//select file and submit it
export const SendModal = ({
  showSendModal,
  setDocuments,
  error,
  setError,
  setIsShareModal,
  setShowSendModal,
  setSelectType,
  selectType,
  handleSubmitDocument,
  setShowDocumentModal,
  documents,
  documentName,
  setDocumentName,
  onDriveFileSelected
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const [accessToken, setAccessToken] = useState(localStorage.getItem("google_access_token") || "");

  const login = useGoogleLogin({
    scope: "https://www.googleapis.com/auth/drive.readonly",
    onSuccess: (tokenResponse) => {
      localStorage.setItem("google_access_token", tokenResponse.access_token);
      setAccessToken(tokenResponse.access_token);

      openDrivePicker(tokenResponse.access_token);
    },
    onError: (error) => {
      console.error("Login Failed:", error);
    },
  });

  const handleSettingDoc = async (file) => {
    try {
      const accessToken = localStorage.getItem("google_access_token");
      if (!accessToken) {
        console.error("Google access token not found");
        return;
      }

      let response;
      let blob;
      let filename = file.name;

      if (file.mimeType.startsWith("application/vnd.google-apps")) {
        let exportMimeType = "application/pdf";

        if (file.mimeType === "application/vnd.google-apps.document") {
          exportMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX
          filename += ".docx";
        } else if (file.mimeType === "application/vnd.google-apps.spreadsheet") {
          exportMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // XLSX
          filename += ".xlsx";
        } else {
          exportMimeType = "application/pdf";
          filename += ".pdf";
        }

        response = await fetch(
          `https://www.googleapis.com/drive/v3/files/${file.id}/export?mimeType=${exportMimeType}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      } else {
        response = await fetch(
          `https://www.googleapis.com/drive/v3/files/${file.id}?alt=media`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      }

      if (!response.ok) {
        throw new Error("Failed to download/export file from Google Drive");
      }

      blob = await response.blob();
      const fetchedFile = new File([blob], filename, { type: blob.type });

      setDocuments([fetchedFile]);
      setDocumentName(fetchedFile.name);
      setSelectType("");
    } catch (error) {
      console.error("Error downloading file from Drive:", error);
    }
  };

  const handleLocalFile = (file) => {
    setDocuments([file]);
    setDocumentName(file.name);
    setSelectType("Mycomputer");
    setShowDocumentModal(false);
  };

  const [openPicker, data] = useDrivePicker();

  const openDrivePicker = (token) => {
    openPicker({
      clientId: "583275220286-ehmmab77l38e0m3ok3afj6qutdmbk9uq.apps.googleusercontent.com",
      developerKey: "AIzaSyAlq4Jc_bCSY-16cUqvgmX26ESYvHJzt14",
      token,
      viewId: "DOCS",
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: false,
      callbackFunction: (data) => {
        if (data.action === "cancel") return;
        const file = data.docs?.[0];
        if (!file) return;

        onDriveFileSelected(file);
        setSelectType("Drive");
        handleSettingDoc(file);
        setShowSendModal(true);
      },
    });
  };

  const handleGoogleDriveClick = () => {
    setShowSendModal(false);
    login();
  };

  const buildDocumentObject = () => {
    const docObject = {};
    if (Array.isArray(documents) && documents.length > 0) {
      const file = documents[0];
      docObject["file"] = file;
    }
    return docObject;
  };

  return (
    <Modal
      show={showSendModal}
      onHide={(e) => {
        setShowSendModal(false);
      }}
    >
      <Modal.Body>
        <div className="promocode_content signout senddoc">
          <Link
            to=""
            onClick={(e) => {
              setShowSendModal(false);
            }}
          >
            +
          </Link>
          <h2>{t("select-documents")}</h2>
          <ul>
            <li>
              <span className="view-message  dont-show">
                <input
                  type="radio"
                  className="mail-radio"
                  name="chk"
                  checked={selectType === "Mydocument"}
                  onChange={(e) => {
                    setSelectType("Mydocument");
                    setIsShareModal(true);
                    setShowSendModal(false);
                  }}
                />
                <span className="circle"></span>
              </span>
              <span className="bothtype">
                <CardPersonIcon />
                <p>
                  <h3>{t("title-my-documents")}</h3>
                  <span>{t("select-files-platform")}</span>
                </p>
              </span>
            </li>
            <li>
              <span className="view-message dont-show">
                <input
                  type="radio"
                  className="mail-radio"
                  name="chk"
                  checked={selectType === "Mycomputer"}
                  onChange={() => {
                    setSelectType("Mycomputer");
                    fileInputRef.current?.click();
                  }}
                />
                <span className="circle"></span>
              </span>

              <input
                type="file"
                ref={fileInputRef}
                hidden
                accept=".doc, .docx, .pdf"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    handleLocalFile(e.target.files[0]);
                    setSelectType("Mycomputer");
                    setDocumentName(e.target.files[0].name);
                    setShowDocumentModal(false);
                  }
                }}
              />

              <span className="bothtype">
                <LaptopIcon />
                <p>
                  <h3>{t("text-computer")}</h3>
                  <span>{t("select-files-computer")}</span>
                </p>
              </span>
            </li>
            {/* <li>
              <span className="view-message  dont-show">
                <input
                  type="radio"
                  className="mail-radio"
                  name="chk"
                  checked={selectType === "Drive"}

                  onChange={(e) => {
                    setSelectType("Drive");
                    handleGoogleDriveClick();
                  }}
                />
                <span className="circle"></span>
              </span>
              <span className="bothtype">
                <PowerIcon />
                <p>
                  <h3>{t("text-drive")}</h3>
                  <span>{t("select-files-drive")}</span>
                </p>
              </span>
            </li> */}
          </ul>
          <div className="file">
            <label>{t("file-name")}</label>
            <div className="group_label">
              <ul>
                {Array.isArray(documents) &&
                  documents.map((doc, i) => (
                    <li key={i}>{doc.name}</li>
                  ))
                }
              </ul>
              <input
                type="file"
                hidden
                onChange={(e) => {
                  handleSettingDoc(e.target.files[0]);
                }}
                onClick={() => {
                  setSelectType("Mycomputer");
                  setShowDocumentModal(false);
                }}
                accept=".doc, .docx,.pdf"
              />
              <button
                onClick={(e) => {
                  if (!documents || documents.length === 0) {
                    setError("Please select a document!");
                    return;
                  }

                  const documentObj = {
                    cv: documents[0]
                  };

                  setError("");

                  handleSubmitDocument(documentObj);
                }}
              >
                {t("text-upload")}
              </button>
            </div>
          </div>
          <p style={{ color: "red" }}>
            {error != "" ? "Please select a document!" : ""}
          </p>
          <p className="hide">

            {t("text-visit")}
            {" "}
            <Link to="/faq" target="_blank">
              {t("text-faq")}
            </Link>
            {" "}
            {t("text-page")}
            {" "}
            <Link to="/safety-center" target="_blank">
              {t("safety-center")}
            </Link>
            {" "}
            {t("safety-tips")}
          </p>
        </div>
      </Modal.Body>
    </Modal >
  );
};